<template>
  <div
    class="facets-selection-fi"
    data-test="facets-selection"
    @click="unselect(element)"
  >
    <slot
      name="display"
      :element="element"
      :facet="facet"
    >
      {{ facet.displayField || facet.name }}:
      <span class="facets-selection-fi__value">
        {{ element.fakeValue || element.name || element.text }}
      </span>
    </slot>
    <span class="facets-selection-fi__close-icon">
      <icon-fi
        icon="delete-text"
        size="0_8"
      />
    </span>
  </div>
</template>

<script>
import { IconFi } from 'atoms';

export default {
  name: 'FacetsSelectionFi',
  components: {
    IconFi,
  },
  props: {
    facet: {
      type: Object,
      default: () => ({}),
    },
    element: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['change'],
  methods: {
    unselect(element) {
      this.$emit('change', {
        value: false,
        element: {
          associatedFieldName: this.facet.associatedFieldName,
          ...element,
          selected: false,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import './facets-selection-fi';
</style>
